export const getBeaconStatus = (beacon) => {
  const manualStatus = beacon?.manualBeaconStatus?.trim();

  if (manualStatus) {
    return manualStatus;
  }

  if (beacon?.isMissing) {
    return 'MISSING';
  }

  if (beacon?.truth?.status === 404 || beacon?.beaconData?.status === 404) {
    return 'NOT_VALIDATED';
  }

  const hasFailures = beacon?.flowComparison?.some(
    (r) => r.passFail === 'Fail' || r.passFail === 'Missing',
  );

  return hasFailures ? 'FAIL' : 'PASS';
};
